import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../../redux/store';
import { DobAuthForm } from './DobAuthForm';
import { Layout } from './Layout';
import { usePatientAuth } from '../hooks/usePatientAuth';
import { PortalResourceType } from '../constants';

interface ProtectedResourcePageProps {
  resourceType: PortalResourceType;
  children: React.ReactNode;
}

export const ProtectedResourcePage = ({ resourceType, children }: ProtectedResourcePageProps) => {
  const { encodedResourceId } = useParams<{ encodedResourceId: string }>();
  const { patientToken } = useSelector((s: RootState) => s.patientAuth);
  const { authenticate, loading, error } = usePatientAuth();

  const handleDobSubmit = async (dob: string) => {
    if (!encodedResourceId) return;
    await authenticate(resourceType, encodedResourceId, dob);
  };

  if (!patientToken) {
    return <DobAuthForm onSubmit={handleDobSubmit} loading={loading} error={error} />;
  }

  return <Layout>{children}</Layout>;
};
